<script>
export default {
  props: ["color"],
};
</script>

<template>
    <svg fill="none" height="34" viewBox="0 0 23 34" width="23" xmlns="http://www.w3.org/2000/svg"><g :fill="color"><path d="m22.9912 22.858c-.0546 1.2702-.3088 2.5037-.7434 3.7016-.8753 2.4101-2.4607 4.2609-4.5711 5.6579-1.0011.6612-2.102 1.1411-3.292 1.4433-1.108.2808-2.2112.3448-3.3383.3388-1.89772-.0106-3.64822-.5498-5.28353-1.4752-2.02365-1.147-3.55445-2.7774-4.58646-4.8545-.698304-1.4041-1.1282135-2.8924-1.17571701-4.4719-.00356276-.1267.00713074-.2535.02019421-.3756h6.0091928c0 .1256.03918.2607.05819.397.31114 2.198 1.55217 3.6661 3.59245 4.4564.67338.2607 1.40018.3531 2.14598.2524.5974-.0818 1.1899-.1161 1.7541-.3804 1.5248-.7168 2.6055-1.7927 3.0829-3.4504.1699-.5901.2839-1.1683.2459-1.7714-.1164-1.8556-.9465-3.3083-2.5011-4.3475-.1983-.1327-.3753-.2985-.6366-.5083 1.7137-1.2406 3.3538-2.4267 5.0437-3.6483.2269.1623.4418.2796.6128.4432 1.3123 1.2524 2.2802 2.7312 2.8776 4.4445.4691 1.3425.7481 2.7206.6852 4.1496z"/><path d="m10.0548 17.8944 12.3272-8.71139v-9.18301h-20.70681v6.03946h14.98021l-6.6077 4.64244z"/></g></svg>
</template>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/participant-numbers/3.vue